// Shared look for the profile dropdown (top navbar and the placement drive header).
export const PROFILE_MENU_CLASS =
	'navbar-profile-dropdown !min-w-[240px] overflow-hidden !rounded-2xl !border !border-[#ECECF3] !bg-white p-1.5 shadow-[0_12px_32px_rgba(20,20,60,0.14)] dark:!border-[#374151] dark:!bg-[#1F2A37] font-inter';

export const PROFILE_MENU_HEADER_CLASS = 'flex flex-col gap-0.5 !rounded-xl !px-3 !py-3 dark:!text-[#C7C9D9]';

export const PROFILE_MENU_ITEM_CLASS =
	'flex items-center gap-2.5 !rounded-xl !px-3 !py-2.5 text-[14px] font-[500] !text-[#111E2C] hover:!bg-[#F4F4F9] dark:!text-[#C7C9D9] dark:hover:!bg-[#374151]';

export const PROFILE_MENU_DANGER_ITEM_CLASS =
	'flex items-center gap-2.5 !rounded-xl !px-3 !py-2.5 text-[14px] font-[500] !text-[#B42318] hover:!bg-[#FDECEC] dark:!text-[#F97066] dark:hover:!bg-[#3A2020]';
